export default __webpack_public_path__ + "static/media/fast.cd2fd344.jpeg";